import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';
import { TargetFromJSON } from '@/apis/generated/dialbunny';
import type { Target } from '@/apis/generated/dialbunny';

export type TargetStore = StoreEntity<Target, 'id', {}>;

export const useTargetStore = apiStoreFactory<
  TargetStore['entity'],
  TargetStore['id'],
  TargetStore['filter'],
  TargetStore['createInput']
>(
  STORE.TARGET,
  { entityIdKey: 'id', supportPagination: false },
  {
    read: async (id, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Target',
        ids: id,
      });

      return result.map(TargetFromJSON)[0];
    },
    bulkRead: async (keys, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Target',
        ids: keys.join(','),
      });

      return result.map(TargetFromJSON);
    },
  },
);
